import React, { useState } from "react";
import { PrimaryButton } from "../Common/PrimaryButton";

const Modal = ({ isOpen, onClose, description, title, link }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "30px",
          borderRadius: "8px",
          width: "80%",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          maxWidth: "800px",
          overflow: "auto",
          maxHeight: "80%",
        }}
        data-aos="fade-up"
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{justifyContent: "flex-end", display: "flex"}}>
        <button
          onClick={onClose}
          style={{
            cursor: "pointer",
            border: "none",
            backgroundColor: "transparent",
            top: "20px",
            right: "20px",
          }}
        >
          <img
            src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
            width={30}
            height={30}
            alt=""
          />
        </button>
        </div>
       
        <p
          style={{
            fontSize: "40px",
            textAlign: "left",
            lineHeight: "1.6",
          }}
        >
          {title}
        </p>
        <p
          style={{
            fontSize: "16px",
            textAlign: "left",
            lineHeight: "1.6",
            whiteSpace: "pre-wrap",
          }}
        >
          {description}
        </p>
        {link && (
          <p
            style={{
              fontSize: "16px",
              textAlign: "left",
              lineHeight: "1.6",
            }}
          >
            Learn More :{" "}
            <a href={link} target="_blank" rel="noreferrer">
              {link}
            </a>
          </p>
        )}
      </div>
    </div>
  );
};

export const PolicyCard = ({
  title,
  caption,
  image,
  description,
  link,
  invert,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div>
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: invert? "wrap" : "wrap-reverse",
            gap: "50px",
          }}
        >
          {invert && (
            <div
              style={{
                flex: "1 1 300px",
                aspectRatio: "3 / 2",
              }}
              data-aos="fade"
            >
              <img
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
                src={image}
                alt={title}
              />
            </div>
          )}
          <div
            style={{
              flex: "1 1 300px",
              gap: "10px",
              display: "flex",
              flexDirection: "column",
              maxWidth: "100%",
            }}
          >
            <p
              style={{
                fontSize: "40px",
                textAlign: "left",
                lineHeight: "1.2",
              }}
              data-aos="fade"
            >
              {title}
            </p>
            <p
              style={{
                fontSize: "16px",
                textAlign: "left",
                lineHeight: "1.6",
              }}
              data-aos="fade"
            >
              {caption}
            </p>
            <div style={{ marginTop: "20px" }}  data-aos="fade">
              <PrimaryButton label="Learn More" onClick={openModal} />
            </div>
          </div>
          {!invert && (
            <div
              style={{
                flex: "1 1 300px",
                aspectRatio: "3 / 2",
              }}
              data-aos="fade"
            >
              <img
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
                src={image}
                alt="Coaching Federation Logo"
              />
            </div>
          )}
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        description={description}
        title={title}
        link={link}
      />
    </div>
  );
};